import { styled } from '@material-ui/core'
import { FieldNumberStandalone } from 'components/Fields/FieldNumber'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getTipoUsuarioLogado } from 'store/modules/auth/auth.selectors'
import { TIPO_USUARIO } from 'utils/constantes'
import { useSelector, useDispatch } from 'react-redux'

const Container = styled('div')(({ theme }) => ({
  padding: 5,
  borderBottom: '1px solid #DFDFDF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const FieldCell = ({ value = '0,00', onChange, disabled = false }) => {
  const inputRef = useRef(null)
  const { t, i18n } = useTranslation()
  const [fieldValue, setFieldValue] = useState(value)

  const handleChange = newValue => {
    if (disabled && value !== '0' && inputRef.current) {
      inputRef.current.element.value = '0'
      setFieldValue('0')
      return
    }
    setFieldValue(newValue)
  }

  const handleSubmit = async () => {
    const status = await onChange(fieldValue || '0')

    // Voltar para o valor original se não salvar
    if (!status) {
      setFieldValue(value)
      inputRef.current.element.value = Number(value)?.toLocaleString('pt-BR', {
        style: 'decimal',
        currency: 'BRL',
        minimumFractionDigits: 2,
      })
    }
  }

  const listenKeyDown = event => {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  useEffect(() => {
    if (fieldValue === '') {
      handleSubmit()
    }
  }, [fieldValue])

  const tipoUsuarioLogado = useSelector(getTipoUsuarioLogado)

  return (
    <Container>
      <FieldNumberStandalone
        label={t('creditosDeBiodiversidade.pontuacaoUtilizada')}
        i18n={i18n}
        value={fieldValue}
        onValueChange={vals => {
          const newValue = vals.floatValue ?? 0
          handleChange(newValue)
        }}
        onKeyDown={listenKeyDown}
        onClick={() => {
          if (Number(fieldValue) === 0 && inputRef.current) {
            inputRef.current.value = ''
          }
        }}
        ref={inputRef}
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        disabled={tipoUsuarioLogado === TIPO_USUARIO.CLIENTE.LEITOR}
      />
    </Container>
  )
}

FieldCell.displayName = 'FieldCell'
